import axios, { AxiosError } from 'axios';
import { useQuery } from 'react-query';

interface HealthData {
  [serviceName: string]: { Status: string };
}

function useServiceHealth(monitoringServiceUrl: string | undefined) {
  return useQuery<HealthData, AxiosError<HealthData | undefined>>(
    ['service-health', monitoringServiceUrl],
    () =>
      axios
        .get(monitoringServiceUrl + '/health')
        .then((response) => response.data)
        .catch((error) => error.response.data),
    {
      retry: (failure, attempt) => {
        const axiosError = attempt as AxiosError;
        return (
          axiosError.response?.status !== 520 &&
          axiosError.response?.status !== 521
        );
      },
    },
  );
}

export default useServiceHealth;
